/**
 * @todo (pr-595) rename this function to `renderEncodedString` or something after we remove serializeNotes / deserializeNotes functions
 * */
export const renderSerializedNotes = (encodedString: string): JSX.Element => {
  return <span style={{ whiteSpace: "pre-wrap", fontSize: "initial" }}>{encodedString}</span>;
};
